import { render, staticRenderFns } from "./ItemLinkForApi.vue?vue&type=template&id=5974430a&scoped=true&lang=pug&"
import script from "./ItemLinkForApi.vue?vue&type=script&lang=js&"
export * from "./ItemLinkForApi.vue?vue&type=script&lang=js&"
import style0 from "./ItemLinkForApi.vue?vue&type=style&index=0&id=5974430a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5974430a",
  null
  
)

export default component.exports